import { Controller } from '@hotwired/stimulus';
import intlTelInput from 'intl-tel-input';

export default class extends Controller {
  connect() {

      if (!this.element.hasAttribute('intlTelInitialized')) {
          this.element.setAttribute('intlTelInitialized', 'true');

          intlTelInput(this.element, {
              initialCountry: 'lt',
              separateDialCode: true,
              autoPlaceholder: 'off',
              nationalMode: false,
              onlyCountries: ['lt'],
          });

          const form = this.element.closest('form');

          if (form) {
              form.addEventListener('submitting', (event) => {
                  const wrapper = this.element.closest('.iti');

                  if (wrapper && event.detail.formData) {
                      const formData = event.detail.formData;
                      const currentValue = formData.get(this.element.name);
                      const currentCodeEl = wrapper.querySelector('.iti__selected-dial-code');

                      if (currentValue && currentCodeEl && currentCodeEl.innerHTML) {
                          formData.set(this.element.name, `${currentCodeEl.innerHTML}${currentValue}`);
                      }
                  }
              });
          }
      }
  }
}
